import { PropsWithChildren } from 'react';
import PrivateBusHeader from '@private-bus/header';
import { useApp } from '@context/app';
import { Sidebar } from '@shared/sidebar';

export const PrivateBusLayout = ({ children }: PropsWithChildren<unknown>) => {
  const { isSidebarOpen } = useApp();

  return (
    <>
      <PrivateBusHeader />
      <main
        sx={{
          display: 'flex',
          height: '100%',
          aside: {
            minWidth: !isSidebarOpen && '80px !important',
          },
        }}
      >
        <>
          <Sidebar />
          <section sx={{ flex: 1, p: 'spacing-m' }}>{children}</section>
        </>
      </main>
    </>
  );
};
